/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';
import { withFormik } from 'formik';
import { Column } from 'rbx';
import * as yup from 'yup';
import swal from 'sweetalert';
// import moment from 'moment';

import { FaAngleLeft } from 'react-icons/fa';
import { Input, MobileInput } from '../../../../components/elements';

const Container = styled.form`
  &&& {
    .modal-background {
      background-color: rgba(13, 13, 13, 0.28);
    }
    .modal-card-body {
      height: 100vh;
      padding: 0px;
    }
    .modal-card {
      max-height: calc(100vh - 0px);
      position: absolute;
      right: 0;
      width: 35rem;
    }
    .modal-card-head,
    .modal-card-foot {
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
    }
    .modal-card-title {
      font-size: 1.5rem;
      font-weight: 600;
    }
    .modal-card-head {
      border-bottom: 0px;
      padding: 1rem 2rem;
      padding-top: 1.5rem;
      background: white;
    }
    .modal-card-foot {
      justify-content: center;
      background: white;
      border-top: 0px;
      .button {
        font-weight: 600;
      }
    }
  }
`;

const CloseButtonWrapper = styled.div`
  position: absolute;
  left: 1rem;
  top: 1rem;
`;

const DetailsFormWrapper = styled.div`
  padding: 1rem 2rem;
`;

const Form = ({
  isActive,
  onClose,
  handleSubmit,
  resetForm,
  values,
  setFieldValue,
  handleChange,
  handleBlur,
  errors,
  touched,
  adminUpdateMenuOrderLoading,
  order,
}) => {
  console.log(order);
  return (
    <Container className={`modal ${isActive && 'is-active'}`}>
      <div className="modal-background" />
      <div className="modal-card">
        <header className="modal-card-head">
          <p
            className="modal-card-title is-flex"
            style={{ justifyContent: 'center' }}
          >
            Update Order
          </p>

          <CloseButtonWrapper>
            <FaAngleLeft
              size={30}
              type="button"
              onClick={() => {
                onClose();
                resetForm();
              }}
            />
          </CloseButtonWrapper>
        </header>

        <section className="modal-card-body">
          <DetailsFormWrapper>
            <Column.Group>
              <div className="column">
                <Input
                  label="Contact Name"
                  name="contact_name"
                  value={values.contact_name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  errors={errors.contact_name}
                  touched={touched.contact_name}
                  disableToastMessage
                />
                <br />
                <MobileInput
                  label="Contact Phone"
                  name="contact_phone"
                  value={values.contact_phone}
                  onChange={value => {
                    setFieldValue('contact_phone', value);
                  }}
                  onBlur={handleBlur}
                  errors={errors.contact_phone}
                  touched={touched.contact_phone}
                  disableToastMessage
                />
                <br />
                {/* <Input
                  name="website0"
                  value={values.website0}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  errors={errors.website0}
                  touched={touched.website0}
                  disableToastMessage
                /> */}
              </div>
            </Column.Group>
          </DetailsFormWrapper>
        </section>
        <footer className="modal-card-foot">
          <button
            className={`button is-large is-fullwidth is-primary ${adminUpdateMenuOrderLoading &&
              'is-loading'}`}
            onClick={handleSubmit}
          >
            UPDATE ORDER
          </button>
        </footer>
      </div>
    </Container>
  );
};

const InfoUpdate = withFormik({
  mapPropsToValues: ({ order }) => ({
    contact_name: order.contact.contact_name,
    contact_phone: order.contact.contact_phone,
  }),

  validationSchema: yup.object().shape({}),

  handleSubmit: (values, { props }) => {
    swal({
      title: 'Are you sure to update the order?',
      buttons: ['Cancel', 'Confirm'],
    }).then(async isConfirm => {
      if (isConfirm) {
        await props.adminUpdateMenuOrder({
          variables: {
            input: {
              menu_order_id: props.order.menu_order_id,
              user_id: props.userId,
              contact: {
                contact_name: values.contact_name,
                contact_phone: values.contact_phone,
              },
            },
          },
        });
      }
    });
  },

  displayName: 'InfoUpdate',
})(Form);

export default InfoUpdate;
